import React from 'react';

export default function LockedModule({ moduleName }) {
  const styles = {
    container: {
      minHeight: '100vh',
      background:
        'linear-gradient(135deg, #0f0f23 0%, #1a1a2e 50%, #16213e 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '40px 20px',
      color: 'white',
      textAlign: 'center',
      position: 'relative',
      overflow: 'hidden'
    },
    backgroundPattern: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundImage: `
        radial-gradient(circle at 20% 80%, rgba(120, 119, 198, 0.1) 0%, transparent 50%),
        radial-gradient(circle at 80% 20%, rgba(255, 119, 198, 0.1) 0%, transparent 50%),
        radial-gradient(circle at 40% 40%, rgba(120, 219, 255, 0.1) 0%, transparent 50%)
      `,
      pointerEvents: 'none'
    },
    content: {
      position: 'relative',
      zIndex: 1,
      background: 'rgba(255, 255, 255, 0.05)',
      borderRadius: '24px',
      padding: '60px 40px',
      backdropFilter: 'blur(20px)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
      maxWidth: '600px'
    },
    icon: {
      fontSize: '3em',
      marginBottom: '30px',
      filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.3))',
      opacity: 0.8
    },
    title: {
      fontSize: '2.5em',
      fontWeight: '700',
      marginBottom: '20px',
      background:
        'linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      letterSpacing: '-0.02em'
    },
    subtitle: {
      fontSize: '1.3em',
      marginBottom: '30px',
      opacity: 0.8,
      fontWeight: '500'
    },
    message: {
      fontSize: '1.1em',
      marginBottom: '40px',
      lineHeight: '1.6',
      opacity: 0.9
    },
    backButton: {
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      padding: '16px 32px',
      borderRadius: '50px',
      textDecoration: 'none',
      fontWeight: '600',
      fontSize: '1.1em',
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 15px rgba(102, 126, 234, 0.4)',
      display: 'inline-block'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.backgroundPattern} />
      <div style={styles.content}>
        <div style={styles.icon}>
          <span role="img" aria-label="Lock">
            🔒
          </span>
        </div>
        <h1 style={styles.title}>Module Verrouillé</h1>
        <h2 style={styles.subtitle}>{moduleName}</h2>
        <p style={styles.message}>
          Ce module n'est pas encore disponible. Il sera débloqué au cours de la
          formation.
        </p>
        <a
          href="#/home"
          style={styles.backButton}
          onMouseEnter={e => {
            e.currentTarget.style.transform = 'scale(1.05)';
            e.currentTarget.style.boxShadow =
              '0 6px 20px rgba(102, 126, 234, 0.6)';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.transform = 'scale(1)';
            e.currentTarget.style.boxShadow =
              '0 4px 15px rgba(102, 126, 234, 0.4)';
          }}>
          ← Retour à l'accueil
        </a>
      </div>
    </div>
  );
}
